import { render, staticRenderFns } from "./AddManager.vue?vue&type=template&id=0edef9fd&scoped=true"
import script from "./AddManager.vue?vue&type=script&lang=js"
export * from "./AddManager.vue?vue&type=script&lang=js"
import style0 from "./AddManager.vue?vue&type=style&index=0&id=0edef9fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edef9fd",
  null
  
)

export default component.exports